import { useMutation } from '@tanstack/react-query';

import { endpoints } from 'global/endpoints';
import http from 'utils/http';

export interface IApproveRequest {
  time_off_entry_id: Array<number>;
  shift_schedule?: number;
  timesheet_entry?: number;
  comment?: string;
}

const approveRequest = (postData: IApproveRequest) => {
  return http().post(endpoints.timeOff.approveRequest, postData);
};

export function useApproveRequest() {
  return useMutation({ mutationFn: approveRequest });
}
